import React, { useState } from 'react';

const SimpleComponentForm = ({ component, onSave, onCancel }) => {
  const [formData, setFormData] = useState({
    type: component?.type || 'general',
    title: component?.title || '',
    description: component?.description || '',
    price: component?.price || 0,
    isOptional: component?.isOptional || false,
    data: component?.data || {}
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave(formData);
  };

  const getComponentTypeName = (type) => {
    const typeNames = {
      'hotel': 'Hotel',
      'flight': 'Flight',
      'car': 'Car Rental',
      'cruise': 'Cruise',
      'activity': 'Activity/Tour',
      'restaurant': 'Restaurant',
      'insurance': 'Travel Insurance',
      'general': 'General Item',
      'disney-wdw': 'Disney World Package',
      'disneyland': 'Disneyland Package',
      'universal-orlando': 'Universal Orlando',
      'universal-hollywood': 'Universal Hollywood'
    };
    return typeNames[type] || 'Travel Component';
  };

  return (
    <>
      <div className="border-b px-6 py-4">
        <h2 className="text-2xl font-bold">Add {getComponentTypeName(formData.type)}</h2>
      </div>
      <form onSubmit={handleSubmit} className="p-6 space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">Title *</label>
          <input
            type="text"
            value={formData.title}
            onChange={(e) => setFormData({ ...formData, title: e.target.value })}
            required
            placeholder="e.g., Grand Wailea Resort"
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Description</label>
          <textarea
            value={formData.description}
            onChange={(e) => setFormData({ ...formData, description: e.target.value })}
            rows="3"
            placeholder="Details about this component..."
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Price *</label>
          <input
            type="number"
            value={formData.price}
            onChange={(e) => setFormData({ ...formData, price: parseFloat(e.target.value) || 0 })}
            required
            min="0"
            step="0.01"
            className="w-full px-3 py-2 border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>
        <div className="flex items-center">
          <input
            type="checkbox"
            checked={formData.isOptional}
            onChange={(e) => setFormData({ ...formData, isOptional: e.target.checked })}
            className="w-4 h-4 text-blue-600 rounded focus:ring-blue-500"
          />
          <label className="ml-2 text-sm font-medium">
            Mark as Optional (client can choose to add this)
          </label>
        </div>
        <div className="flex justify-end space-x-3 pt-4 border-t">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-2 border rounded-lg hover:bg-gray-50"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
          >
            {component?.title ? 'Update Component' : 'Add Component'}
          </button>
        </div>
      </form>
    </>
  );
};

export default SimpleComponentForm;
